export default __webpack_public_path__ + "static/media/fish_oil5.6fd0f5e2.png";